import { z } from 'zod';

/** Validation schema for the register/voucher-choice form. */
export const voucherChoiceSchema = z.object({
    voucherEducationChoice: z.string().min(1, 'Required'),
});
